// extracted by mini-css-extract-plugin
module.exports = {"root":"root-2BD2P","container":"container-3yUB7","type_review":"type_review-2JWBM","type_account":"type_account-3stEO","preview":"preview-2sPPG"};